// extracted by mini-css-extract-plugin
export default {"main":"MasterCard_main__jqUx4","icon":"MasterCard_icon__ZdPMa"};